// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .progressbar {
  position: relative;
  margin: 20px 0;
}

.progress-bar-container {
  position: relative;
  width: 100%;
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 10px;
  cursor: pointer;
}

.progress-bar {
  position: absolute;
  height: 100%;
  background-color: #8E3E63;
  border-radius: 10px;
}

.marker {
  position: absolute;
  width: 30px;
  height: 30px;
  background-color: #ff6f61;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
idth: 32px; /* Adjust size as needed */


.popup {
  position: absolute;
  background-color: #000;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  transform: translateX(-50%);
}




.answer-list li {
  display: flex;
  align-items: center;
  margin-bottom: 12px; /* Adjust space between options */
}

.circle-indicator {
  width: 25px; /* Fixed width */
  height: 25px; /* Fixed height */
  background-color: #E66194; /* Pink color for the circles */
  border-radius: 50%; /* Makes the div a perfect circle */
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 0.875rem; /* Size for the text inside the circle */
  line-height: 1; /* Ensures text is centered vertically */
  flex-shrink: 0; /* Prevents the circle from shrinking */
}

.circle-A {
  background-color: #C9A2C9;
}

.circle-B {
  background-color: #975C8D;
}

.circle-C {
  background-color: #E36BAE;
}

/* CSS for progress bar container */
.progress-bar-container {
  /* margin: 0;
  padding: 0; */
  position: relative;
  height: 20px; /* Adjust the height as needed */
  background: linear-gradient(to right, #C9A2C9, #975C8D, #E36BAE);
  border-radius: 10px; /* Optional: adds rounded corners */
}

/* CSS for progress bar */
.progress-bar {
  height: 100%;
  background: linear-gradient(to right, #C9A2C9, #975C8D, #E36BAE); /* Gradient color for the progress bar */
  border-radius: 10px; /* Optional: adds rounded corners */
  transition: width 0.3s ease; /* Smooth transition for the progress */
}

/* CSS for handle */
.progress-indicator {
  position: absolute;
  top: -25px;
  transform: translateX(-50%);
  color: #000;
  background: linear-gradient(to right, #C9A2C9, #975C8D, #E36BAE); /* Gradient color for the handle */
  padding: 2px 5px;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease; 
  white-space: nowrap; /* Prevents text from wrapping */
}
.progress-bar-indicator.hover-gray:hover {
  background-color: #cccccc; /* Gray color on hover */
}


.marker.small {
  width: 2px; /* Adjust the width as needed */
  height: 10px; /* Standard height for small markers */
  position: absolute;
  top: 50%; /* Center vertically */
  transform: translateY(-50%);
  background-color: #ccc; /* Light gray color */
}

.marker.small.middle {
  height: 15px; /* Slightly longer height for middle markers */
}

.slider-handle {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
  background-color: #ffffff;
  border: 2px solid #975C8D; /* Change to fit your gradient colors */
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  transition: left 0.3s ease;
}

`, "",{"version":3,"sources":["webpack://./src/components/Partnership/Partnership.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;sCAgCsC;;;AAGtC;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;;;;AAKA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB,EAAE,iCAAiC;AACxD;;AAEA;EACE,WAAW,EAAE,gBAAgB;EAC7B,YAAY,EAAE,iBAAiB;EAC/B,yBAAyB,EAAE,+BAA+B;EAC1D,kBAAkB,EAAE,mCAAmC;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB,EAAE,wCAAwC;EAC7D,cAAc,EAAE,wCAAwC;EACxD,cAAc,EAAE,uCAAuC;AACzD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE;eACa;EACb,kBAAkB;EAClB,YAAY,EAAE,gCAAgC;EAC9C,gEAAgE;EAChE,mBAAmB,EAAE,mCAAmC;AAC1D;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,gEAAgE,EAAE,wCAAwC;EAC1G,mBAAmB,EAAE,mCAAmC;EACxD,2BAA2B,EAAE,uCAAuC;AACtE;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,gEAAgE,EAAE,kCAAkC;EACpG,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,sCAAsC;EACtC,mBAAmB,EAAE,gCAAgC;AACvD;AACA;EACE,yBAAyB,EAAE,wBAAwB;AACrD;;;AAGA;EACE,UAAU,EAAE,+BAA+B;EAC3C,YAAY,EAAE,sCAAsC;EACpD,kBAAkB;EAClB,QAAQ,EAAE,sBAAsB;EAChC,2BAA2B;EAC3B,sBAAsB,EAAE,qBAAqB;AAC/C;;AAEA;EACE,YAAY,EAAE,8CAA8C;AAC9D;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB,EAAE,uCAAuC;EAClE,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,0BAA0B;AAC5B","sourcesContent":["/* .progressbar {\n  position: relative;\n  margin: 20px 0;\n}\n\n.progress-bar-container {\n  position: relative;\n  width: 100%;\n  height: 20px;\n  background-color: #e0e0e0;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.progress-bar {\n  position: absolute;\n  height: 100%;\n  background-color: #8E3E63;\n  border-radius: 10px;\n}\n\n.marker {\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  background-color: #ff6f61;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\nidth: 32px; /* Adjust size as needed */\n\n\n.popup {\n  position: absolute;\n  background-color: #000;\n  color: #fff;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: nowrap;\n  transform: translateX(-50%);\n}\n\n\n\n\n.answer-list li {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px; /* Adjust space between options */\n}\n\n.circle-indicator {\n  width: 25px; /* Fixed width */\n  height: 25px; /* Fixed height */\n  background-color: #E66194; /* Pink color for the circles */\n  border-radius: 50%; /* Makes the div a perfect circle */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: bold;\n  font-size: 0.875rem; /* Size for the text inside the circle */\n  line-height: 1; /* Ensures text is centered vertically */\n  flex-shrink: 0; /* Prevents the circle from shrinking */\n}\n\n.circle-A {\n  background-color: #C9A2C9;\n}\n\n.circle-B {\n  background-color: #975C8D;\n}\n\n.circle-C {\n  background-color: #E36BAE;\n}\n\n/* CSS for progress bar container */\n.progress-bar-container {\n  /* margin: 0;\n  padding: 0; */\n  position: relative;\n  height: 20px; /* Adjust the height as needed */\n  background: linear-gradient(to right, #C9A2C9, #975C8D, #E36BAE);\n  border-radius: 10px; /* Optional: adds rounded corners */\n}\n\n/* CSS for progress bar */\n.progress-bar {\n  height: 100%;\n  background: linear-gradient(to right, #C9A2C9, #975C8D, #E36BAE); /* Gradient color for the progress bar */\n  border-radius: 10px; /* Optional: adds rounded corners */\n  transition: width 0.3s ease; /* Smooth transition for the progress */\n}\n\n/* CSS for handle */\n.progress-indicator {\n  position: absolute;\n  top: -25px;\n  transform: translateX(-50%);\n  color: #000;\n  background: linear-gradient(to right, #C9A2C9, #975C8D, #E36BAE); /* Gradient color for the handle */\n  padding: 2px 5px;\n  border-radius: 4px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  transition: background-color 0.3s ease; \n  white-space: nowrap; /* Prevents text from wrapping */\n}\n.progress-bar-indicator.hover-gray:hover {\n  background-color: #cccccc; /* Gray color on hover */\n}\n\n\n.marker.small {\n  width: 2px; /* Adjust the width as needed */\n  height: 10px; /* Standard height for small markers */\n  position: absolute;\n  top: 50%; /* Center vertically */\n  transform: translateY(-50%);\n  background-color: #ccc; /* Light gray color */\n}\n\n.marker.small.middle {\n  height: 15px; /* Slightly longer height for middle markers */\n}\n\n.slider-handle {\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 20px;\n  height: 20px;\n  background-color: #ffffff;\n  border: 2px solid #975C8D; /* Change to fit your gradient colors */\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);\n  transition: left 0.3s ease;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
